import Loadable from 'react-loadable'

const hunaRoutes = [
  {
    path: '/home',
    exact: true,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-HomeX" */ '../pages/home_yaaro'),
      loading: () => null,
    }),
  },
  // 用户协议
  {
    path: '/yaaro/about/userAgreement',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutTsSocial" */ '../pages/aboutTs_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 帐户删除策略
  {
    path: '/yaaro/about/memberDelete',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutDpX" */ '../pages/aboutDp_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 隐私政策
  {
    path: '/yaaro/about/privacyAgreement',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutPpX" */ '../pages/aboutPp_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 社区规则
  {
    path: '/yaaro/about/communityGuidelines',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/aboutCg_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 儿童协议
  {
    path: '/yaaro/about/childSexualAbusePolicy',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/aboutCsap_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 第三方sdk
  {
    path: '/yaaro/about/thirdPartySDK',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/about3rd_yaaro'
        ),
      loading: () => null,
    }),
  },
  // 联系我们
  {
    path: '/yaaro/about/contactUs',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutContact" */ '../pages/aboutContact_yaaro'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/yaaro/about/contactUs/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutContactEn" */ '../pages/aboutContact_yaaro/aboutContactEn'
        ),
      loading: () => null,
    }),
  },
  // 帮助
  {
    path: '/yaaro/help/qa',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestions" */ '../pages/helpQuestions_yaaro/helpQuestionsEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/yaaro/help/qa/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/helpQuestions_yaaro/helpQuestionsEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/yaaro/cpRankRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/cpRankRule'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/yaaro/billboardRankRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/billboardRule_huna'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescription" */ '../pages/VipDesciption'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/zh',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionZh" */ '../pages/VipDesciption/VipDesciptionZh'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionEn" */ '../pages/VipDesciption/VipDesciptionEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/ar',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionAr" */ '../pages/VipDesciption/VipDescriptionAr'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/tr',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionTr" */ '../pages/VipDesciption/VipDescriptionTr'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/id',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionId" */ '../pages/VipDesciption/VipDesciptionId'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/hi',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionHi" */ '../pages/VipDesciption/VipDesciptionHi'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/vi',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionVn" */ '../pages/VipDesciption/VipDesciptionVi'
        ),
      loading: () => null,
    }),
  },
]

export default hunaRoutes
